import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { debounce } from 'lodash'
import { Container, ItemBox, Item } from './style'
import { Section } from '../section'
import { useProvider } from '../../provider/Provider'
import { changeQuery, changeSearch, changeType } from '../../provider/actions'

const Ecossisitema = () => {
    const history = useHistory()
    const { dispatch } = useProvider()
    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        changeSearch(dispatch, '')
    }, [])

    const handler = useCallback(
        debounce((value) => {
            changeQuery(dispatch, {
                page: 1,
                search: value,
                limit: 6,
                area: '',
                city: '',
                type: '',
                admin: false
            })
            history.push('/buscar')
        }, 400), []
    )

    function onChangeSearch(value: string) {
        setInputValue(value)
        handler(value)
    }

    const clearFilters = () => {
        changeQuery(dispatch, {
            limit: 6,
            page: 1,
            search: '',
            area: '',
            city: '',
            type: '',
            admin: false
        })
    }

    const onClickStartups = () => {
        clearFilters()
        changeType(dispatch, 'Startup')
        history.push('/buscar')
    }

    const onClickComunidades = () => {
        clearFilters()
        changeType(dispatch, 'Comunidade')
        history.push('/buscar')
    }

    const onClickIncubadoras = () => {
        clearFilters()
        changeType(dispatch, 'Incubadora')
        history.push('/buscar')
    }

    const onClickVerMais = () => {
        clearFilters()
        history.push('/buscar')
    }

    return (
        <Section>
            <Container>
                <div className="search-box">
                    <p>
                        A plataforma que junta os atores do ecossistema
                        empreendedor, inovador e das startups de Sergipe
                    </p>
                    <div className="search">
                        <div className="input-group input-group-lg my-4">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="form1">
                                    <i className="fas fa-search" />
                                </span>
                            </div>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Busque por startups,
                                    aceleradoras, comunidades..."
                                aria-describedby="form1"
                                value={inputValue}
                                onChange={(e) => {
                                    onChangeSearch(e.target.value)
                                }}
                            />
                        </div>
                    </div>
                </div>
                <ItemBox>
                    <Item onClick={onClickStartups}>
                        <i className="fas fa-rocket fa-lg" />
                        <p>Startups</p>
                    </Item>
                    <Item onClick={onClickComunidades}>
                        <i className="fas fa-users fa-lg" />
                        <p>Comunidades</p>
                    </Item>
                    <Item onClick={onClickIncubadoras}>
                        <i className="fas fa-warehouse fa-lg" />
                        <p>Incubadoras</p>
                    </Item>
                    <Item onClick={onClickVerMais}>
                        <i className="fas fa-arrow-circle-right fa-lg" />
                        <p>Ver mais</p>
                    </Item>
                </ItemBox>
            </Container>
        </Section>
    )
}

export default Ecossisitema
